/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import {useTranslation} from 'react-i18next'
import clsx from 'clsx'
import {XMarkIcon} from '@heroicons/react/24/solid'

type UiDialogHeaderProps = {
    title?: React.ReactNode
    onClose: () => void
    showClose?: boolean
    className?: string
}

const UiDialogHeader: React.FC<UiDialogHeaderProps> = ({
    title,
    onClose,
    showClose = true,
    className,
}) => {
    const {t} = useTranslation()
    return (
        <div
            className={clsx(
                'UiDialogHeader shrink-0 flex items-center justify-between gap-4 px-6 py-4 border-b border-gray-100 bg-white text-gray-900',
                'dark:bg-gray-950 dark:text-gray-100 dark:border-gray-800/50',
                className
            )}
        >
            <div className="min-w-0 flex-1">
                {title && (
                    <div className="truncate text-xs font-extrabold uppercase tracking-widest text-cta-600 dark:text-cta-400">
                        {title}
                    </div>
                )}
            </div>
            {showClose && (
                <button
                    type="button"
                    aria-label={t('Close')}
                    title={t('Close')}
                    className="print:hidden bg-red-500 text-white size-11 shrink-0 flex items-center justify-center transition-colors hover:bg-red-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cta-light focus-visible:ring-offset-2 rounded-bl-md rounded-tr-md"
                    onClick={onClose}
                >
                    <XMarkIcon className="text-white hover:opacity-70 w-4" />
                </button>
            )}
        </div>
    )
}

export default UiDialogHeader
